import React from "react";
import ERPSBaseButton from "./ERPSBaseButton";
import DialogHeader from "./ERPSBaseModelDialog";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogContent, Typography } from "../../primitives";

export default function CustomModelDialog(props) {
  const { t } = useTranslation();
  const {
    open,
    handleRedirect,
    handleClose
  } = props;

  const getDialogContent = () => {
    return (
      <Typography gutterBottom aria-describedby="dialog-message">
        {t(
          "erps.popup.body.contentV1",
          "Are you sure you want to Cancel and continue?"
        )}
      </Typography>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
    >
      <DialogHeader
        id="alert-dialog-title"
        onClose={handleClose}
      >
        {t("erps.popup.header.title", "Unsaved changes")}{" "}
      </DialogHeader>
      <DialogContent
        id="alert-dialog-description"
      >
        {getDialogContent()}
      </DialogContent>
      <DialogActions >
        <ERPSBaseButton
          variant="secondary"
          onClick={handleRedirect}
          label={t("erps.common.label.yes")}
        />
        <ERPSBaseButton
          variant="primary"
          onClick={handleClose}
          label={t("erps.common.label.no")}
        />
      </DialogActions>
    </Dialog>
  );
}
